import {
  updateDoc,
  doc,
  collection,
  type FirestoreError,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { firestore, firebaseFunctions } from "@/helpers/firebase/firebase";
import { handleFirestoreException } from "@/helpers/exceptions/handler";

/**
 * Delete the invite link for a group
 * Removes both the token and timestamp from the group document
 */
export async function deleteInviteLink(groupId: string): Promise<void> {
  try {
    const groupCollection = collection(firestore, "groups/");
    const groupDoc = doc(groupCollection, groupId);

    await updateDoc(groupDoc, {
      join_token: null,
      join_token_timestamp: null,
    });
  } catch (e) {
    handleFirestoreException({ e: e as FirestoreError });
    throw e;
  }
}

/**
 * Generate a new invite link for a group
 * @param groupId The group ID to generate a link for
 * @param timeToDie Time until expiration in hours (default: 168 hours = 7 days)
 */
export async function generateInviteLink(
  groupId: string,
  timeToDie: number = 168,
): Promise<void> {
  const generateLinkFunction = httpsCallable(
    firebaseFunctions,
    "generateInviteToken",
  );

  await generateLinkFunction({
    groupId,
    timeToDie,
  });
}
